import { z } from 'zod';
import { IdZ, NameZ, TsZ, textZ } from './common';
import { PortraitArtRefZ } from './media';

/**
 * A player is a basketball identity (it may have no phone). A member is a login linked
 * to at most one player. A guest is a player with isGuest true and no member (R10).
 */

export const HandZ = z.enum(['L', 'R']);
export const JerseyZ = z.number().int().min(0).max(99);
export const HeightCmZ = z.number().int().min(100).max(250);
export const NicknameZ = textZ(1, 24);

export const PlayerZ = z.object({
  id: IdZ,
  displayName: NameZ,
  nickname: NicknameZ.nullable(),
  jersey: JerseyZ.nullable(),
  heightCm: HeightCmZ.nullable(),
  hand: HandZ.nullable(),
  isGuest: z.boolean(),
  memberId: IdZ.nullable(),
  archivedAt: TsZ.nullable(),
  activePortraitId: IdZ.nullable(),
  /** Others may make this player's AI card (default false). The subject can always hide or delete. */
  allowCrewPortraits: z.boolean(),
  createdAt: TsZ,
  updatedAt: TsZ,
});
export type Player = z.infer<typeof PlayerZ>;

export const PlayerListItemZ = PlayerZ.extend({
  portrait: PortraitArtRefZ.nullable(),
});
export type PlayerListItem = z.infer<typeof PlayerListItemZ>;

export const PlayerDetailZ = PlayerListItemZ.extend({
  member: z.object({ id: IdZ, role: z.enum(['owner', 'member']), joinedAt: TsZ }).nullable(),
  /** True once The Arc, Midrange Tour, Layup Line and Charity Stripe are done. */
  coreCombineDone: z.boolean(),
});
export type PlayerDetail = z.infer<typeof PlayerDetailZ>;

export const PlayerCreateZ = z.object({
  id: IdZ,
  displayName: NameZ,
  nickname: NicknameZ.nullable().optional(),
  jersey: JerseyZ.nullable().optional(),
  heightCm: HeightCmZ.nullable().optional(),
  hand: HandZ.nullable().optional(),
  isGuest: z.boolean().default(true),
});
export type PlayerCreate = z.input<typeof PlayerCreateZ>;

export const PlayerPatchZ = z
  .object({
    displayName: NameZ,
    nickname: NicknameZ.nullable(),
    jersey: JerseyZ.nullable(),
    heightCm: HeightCmZ.nullable(),
    hand: HandZ.nullable(),
    allowCrewPortraits: z.boolean(),
  })
  .partial();
export type PlayerPatch = z.infer<typeof PlayerPatchZ>;
